import Heartbeat from 'components/helper/Heartbeat';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as eventsAC } from 'store/events';
import { getIsAuthenticated } from 'store/login';

export type HeartbeatMapStateToPropsType = {
	isAuthenticated: boolean;
};

export type HeartbeatMapDispatchToPropsType = {
	doRequestAsyncEvents: () => void;
};

const mapStateToProps = (state: any): HeartbeatMapStateToPropsType => ({
	isAuthenticated: getIsAuthenticated(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doRequestAsyncEvents: eventsAC.doRequestAsyncEvents,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Heartbeat as any);
